import React, { Fragment, useState } from 'react';
import BotoesHome from '../../../components/home/botoes-home/index';
import NavBar from '../../../components/layout/navbar/index';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import DashboardHome from '../../../components/home/dashboard-home'
import InfoHome from '../../../components/home/info-home';
import theme from './../../../components/layout/theme';
import Joyride from 'react-joyride';


const tema = theme();

const useStyles = makeStyles(theme => ({
    controlaContainer: {
        backgroundColor: '#F1F1F1',
        padding: 30,
        minHeight: "100%",
    },
    controlaLogo: {
        width: tema.logoWidth,
        marginBottom: 30
    },
    controlaNomeVersao: {
        position: 'absolute',
        left: '40%',
        bottom: 0,
    },
}))


export default function Home(props) {

    const classes = useStyles();
    // const [iniciarTour, setiniciarTour] = useState(props.location.state.iniciarTour ? props.location.state.iniciarTour : false);
    const [iniciarTour, setiniciarTour] = useState(false);
    const [tourHelpers, setTourHelpers] = useState();
    const [steps] = useState([
        {
            content: <h2>Bem Vindo ao Emissor Simple Work !</h2>,
            placement: 'center',
            target: 'body',
        },
        {
            content: <h2>Vamos passar pelas funções do emissor.</h2>,
            placement: 'center',
            target: 'body',
        },
        {
            content: <h2>Painel para informações sobre as notas fiscais.</h2>,
            target: "#dashboard-home",
        },
        {
            content: <h2>Botões de acesso rapido as funções principais.</h2>,
            target: '#home-botoes',
        },
        {
            content: <h2>Cadastro de produto</h2>,
            target: '#home-cadastro-produto',
        },
        {
            content: <h2>Cadastro de pessoa.</h2>,
            target: '#home-cadastro-pessoa',
        },
        {
            content: <h2>Cadastro nota fiscal eletronica.</h2>,
            target: '#home-cadastro-nota-fiscal',
        },
        {
            content: <h2>Para acessar o menu completo de funções basta clicar neste botão.</h2>,
            target: '#botao-nav',
            disableBeacon: true,
            disableOverlayClose: true,
            hideCloseButton: true,
            hideFooter: true,
            placement: 'bottom',
            spotlightClicks: true,
        },
        {
            content: <h2>Documentos Eletronicos.</h2>,
            target: '#nav-documentos',
        },
        {
            content: <h2>Cadastro nota fiscal eletronica.</h2>,
            target: '#nav-cadastro-nota-fiscal',
        },
        {
            content: <h2>Cadastros Gerais.</h2>,
            target: '#nav-cadastros',
            title: 'Cadastros'
        },
        {
            content: <h2>cadastro produto.</h2>,
            target: '#nav-cadastro-produto',
        },
        {
            content: <h2>cadastro pessoa.</h2>,
            target: '#nav-cadastro-pessoa',
        },
        {
            content: <h2>cadastro grupoimposto.</h2>,
            target: '#nav-cadastro-grupo-imposto',
        },
        {
            content: <h2>Parte referente configurações do emissor.</h2>,
            target: '#nav-conta',
        },
        {
            content: <h2>Acesso para carregar ou alterar no certificado eletronico da empresa.</h2>,
            target: '#nav-certificado',
        },
        {
            content: <h2>Tela para fazer configurações gerais no emissor.</h2>,
            target: '#nav-configurar',
        },
        {
            content: <h2>botão para sair do emissor.</h2>,
            target: '#nav-sair',
        },
    ]);

    function handleJoyrideCallback(CallBackProps) {
        if (CallBackProps.action === 'close') {
            setiniciarTour(false);
        }
        if (CallBackProps.action === 'stop' || CallBackProps.action === 'reset') {
            setiniciarTour(false);
            tourHelpers.reset();
        }
    };

    function getHelpers(helpers) {
        setTourHelpers(helpers);
    };

    return (
        <Fragment>
            <Joyride
                debug={false}
                callback={handleJoyrideCallback}
                getHelpers={getHelpers}
                steps={steps}
                continuous={true}
                run={iniciarTour}
                locale={{ back: 'Voltar', close: 'Fechar', last: 'Ultimo', next: 'Proximo', skip: 'Sair' }}
                disableOverlayClose={true}
                styles={{
                    options: {
                        zIndex: 10000,
                    },
                }}
            />
            <span id="span-nav-bar">
                <NavBar tourHelpers={tourHelpers} />
            </span>

            <Container className={classes.controlaContainer}>
                <Grid container>
                    <DashboardHome />
                    <Grid item xs={12} align="center">
                        <img
                            src={tema.logo}
                            alt="SimpleWork"
                            className={classes.controlaLogo}
                        />
                    </Grid>
                    <BotoesHome />
                    <InfoHome />
                </Grid>
                {/* <Typography
                    variant="subtitle1"
                    className={classes.controlaNomeVersao}
                >
                    SwNFeNet
                    </Typography> */}
            </Container>
        </Fragment>
    )
}